// =============================================================================
// Ella Custom JS - Customize The Style For Layout
// =============================================================================

// =============================================================================
// Mukhi Singh predictive catalogue search v3.0
// Runs only inside this theme asset. Does not change products or publish a theme.
// =============================================================================

(() => {
  if (window.MukhiFuzzySearchLoaded) return;
  window.MukhiFuzzySearchLoaded = true;
  window.MukhiFuzzySearchVersion = '3.0';

  const CONFIG = {
    minChars: 2,
    debounceMs: 180,
    limit: 10,
    maxProductPages: 20,
    productsEndpoint: '/products.json',
    searchSuggestEndpoint: '/search/suggest.json',
    cacheKey: 'ms-predictive-catalog-v3',
    cacheTtlMs: 6 * 60 * 60 * 1000,
    corrections: [
      { term: 'benefit', aliases: ['banifut', 'banufoot', 'benifit', 'banefit', 'benefitt', 'benefit cosmetics', 'benefitcosmetics'] },
      { term: 'laura mercier', aliases: ['lora mercier', 'laura mercer', 'lara mercier', 'laura merceir', 'loramercier', 'lora mersier', 'laura mersier', 'laora mercier', 'laura mercie', 'laura mercir', 'laura marcie', 'lorra mercier'] },
      { term: 'too faced', aliases: ['toofaced', 'too face', 'two faced', 'to faced', 'too fases', 'too facd'] },
      { term: 'urban decay', aliases: ['urban dekey', 'urban decaay', 'urban decy', 'urban dkey', 'urban decayy'] },
      { term: 'character', aliases: ['charecter', 'charactor', 'character cosmetic', 'charecter cosmetics', 'character cosmetics', 'charcter'] },
      { term: 'forever 52', aliases: ['forever52', 'forevr 52', 'forever fifty two', 'forever fiftytwo', 'forver 52', 'forevr52'] },
      { term: 'nars', aliases: ['naars', 'narse', 'nars cosmetics', 'narscosmetics'] },
      { term: 'dior', aliases: ['dioor', 'diorr', 'diior'] },
      { term: 'mac', aliases: ['mack', 'mac cosmetics', 'macc'] },
      { term: 'rare beauty', aliases: ['rare beuty', 'rarebeauty', 'raree beauty'] },
      { term: 'huda beauty', aliases: ['huda beuty', 'hudabeauty', 'huda beauti'] },
      { term: 'charlotte tilbury', aliases: ['charlote tilbury', 'charlotte tilburry', 'charlit tilbury', 'charlotte tilburry'] },
      { term: 'patrick ta', aliases: ['patrik ta', 'patrick taa', 'patrickta'] },
      { term: 'laneige', aliases: ['laniege', 'laneigee', 'laniege lip'] },
      { term: 'shiseido', aliases: ['shishedo', 'shiseedo', 'shisheido'] },
      { term: 'embryolisse', aliases: ['embriolisse', 'embreolisse', 'embryolise'] },
      { term: 'd alba', aliases: ['dalba', "d'alba", 'd albaa'] },
      { term: 'fenty beauty', aliases: ['fenti beauty', 'fenty beuty', 'fentybeauty'] },
      { term: 'armani beauty', aliases: ['armani beuty', 'armanibeauty', 'giorgio armani'] },
      { term: 'tarte', aliases: ['tart', 'tarte cosmetics'] },
      { term: 'rhode', aliases: ['rode', 'rhoad', 'rodhe', 'rohd', 'rhode skin', 'rhodeskin'] }
    ]
  };

  const inputState = new WeakMap();
  let indexPromise = null;
  let productIndex = [];
  let vocabulary = [];
  let vocabularySet = new Set();
  let vocabularyByFirst = new Map();
  let wordFrequency = new Map();

  const clean = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const tight = (value) => clean(value).replace(/\s+/g, '');
  const words = (value) => clean(value).split(' ').filter(Boolean);

  const money = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const number = Number(value);
    if (Number.isNaN(number)) return String(value);
    return `₹${number % 1 === 0 ? number.toFixed(0) : number.toFixed(2)}`;
  };

  const debounce = (fn, wait) => {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn(...args), wait);
    };
  };

  function damerauDistance(a, b) {
    a = clean(a);
    b = clean(b);
    if (!a || !b) return Math.max(a.length, b.length);
    if (a === b) return 0;

    const matrix = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));
    for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );

        if (
          i > 1 &&
          j > 1 &&
          a[i - 1] === b[j - 2] &&
          a[i - 2] === b[j - 1]
        ) {
          matrix[i][j] = Math.min(matrix[i][j], matrix[i - 2][j - 2] + cost);
        }
      }
    }

    return matrix[a.length][b.length];
  }

  function jaroWinkler(a, b) {
    a = clean(a);
    b = clean(b);
    if (!a || !b) return 0;
    if (a === b) return 1;

    const range = Math.max(0, Math.floor(Math.max(a.length, b.length) / 2) - 1);
    const aMatches = Array(a.length).fill(false);
    const bMatches = Array(b.length).fill(false);
    let matches = 0;

    for (let i = 0; i < a.length; i++) {
      const start = Math.max(0, i - range);
      const end = Math.min(i + range + 1, b.length);
      for (let j = start; j < end; j++) {
        if (bMatches[j] || a[i] !== b[j]) continue;
        aMatches[i] = true;
        bMatches[j] = true;
        matches += 1;
        break;
      }
    }

    if (!matches) return 0;

    const matchedA = [];
    const matchedB = [];
    aMatches.forEach((matched, index) => matched && matchedA.push(a[index]));
    bMatches.forEach((matched, index) => matched && matchedB.push(b[index]));

    let transpositions = 0;
    for (let i = 0; i < matchedA.length; i++) {
      if (matchedA[i] !== matchedB[i]) transpositions += 1;
    }

    const jaro = (
      matches / a.length +
      matches / b.length +
      (matches - transpositions / 2) / matches
    ) / 3;

    let prefix = 0;
    while (prefix < 4 && prefix < a.length && prefix < b.length && a[prefix] === b[prefix]) {
      prefix += 1;
    }

    return jaro + prefix * 0.1 * (1 - jaro);
  }

  function diceCoefficient(a, b) {
    a = tight(a);
    b = tight(b);
    if (!a || !b) return 0;
    if (a === b) return 1;
    if (a.length < 2 || b.length < 2) return 0;

    const pairs = new Map();
    for (let i = 0; i < a.length - 1; i++) {
      const pair = a.slice(i, i + 2);
      pairs.set(pair, (pairs.get(pair) || 0) + 1);
    }

    let intersection = 0;
    for (let i = 0; i < b.length - 1; i++) {
      const pair = b.slice(i, i + 2);
      const count = pairs.get(pair) || 0;
      if (!count) continue;
      intersection += 1;
      pairs.set(pair, count - 1);
    }

    return (2 * intersection) / (a.length + b.length - 2);
  }

  function phoneticKey(value) {
    const token = clean(value);
    if (!token) return '';
    return token[0] + token
      .slice(1)
      .replace(/[aeiouy]/g, '')
      .replace(/(.)\1+/g, '$1');
  }

  function tokenSimilarity(a, b) {
    a = clean(a);
    b = clean(b);
    if (!a || !b) return 0;
    if (a === b) return 1;
    if (b.startsWith(a) && a.length >= 3) return 0.96;
    if (a.startsWith(b) && b.length >= 3) return 0.92;

    const maxLength = Math.max(a.length, b.length);
    const editScore = Math.max(0, 1 - damerauDistance(a, b) / maxLength);
    const jaroScore = jaroWinkler(a, b);
    const diceScore = diceCoefficient(a, b);
    let score = Math.max(editScore, jaroScore * 0.98, diceScore * 0.94);

    if (phoneticKey(a) === phoneticKey(b) && a[0] === b[0]) score = Math.max(score, 0.84);
    if (a[0] !== b[0]) score *= 0.93;
    return score;
  }

  function phraseSimilarity(a, b) {
    a = clean(a);
    b = clean(b);
    if (!a || !b) return 0;
    if (a === b) return 1;
    if (a.includes(b) || b.includes(a)) return 0.94;
    return Math.max(
      jaroWinkler(a, b),
      diceCoefficient(a, b),
      1 - damerauDistance(a, b) / Math.max(a.length, b.length)
    );
  }

  function replaceKnownMisspelling(query) {
    const q = clean(query);
    const qt = tight(query);
    if (q.length < CONFIG.minChars) return q;

    for (const item of CONFIG.corrections) {
      const term = clean(item.term);
      const termTight = tight(term);
      const aliases = item.aliases.map(clean).filter(Boolean);

      if (q === term || qt === termTight) return term;

      for (const alias of aliases) {
        const aliasTight = tight(alias);
        if (q === alias || qt === aliasTight) return term;
        if (q.includes(alias)) return q.replace(alias, term);
        if (qt.includes(aliasTight)) return term;
      }
    }

    return q;
  }

  function compactProduct(product) {
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    const title = String(product.title || '').trim();
    const type = String(product.product_type || product.productType || '').trim();
    const vendor = String(product.vendor || '').trim();
    const handle = String(product.handle || '').trim();
    const image = product.images && product.images.length
      ? product.images[0].src || product.images[0]
      : product.image && (product.image.src || product.image) || '';
    const price = product.variants && product.variants.length ? product.variants[0].price : '';
    const titleWords = words(title);
    const typeWords = words(type);
    const tagWords = words(tags.join(' '));
    const vendorWords = vendor.toLowerCase() === 'mukhi singh' ? [] : words(vendor);
    const allWords = Array.from(new Set(titleWords.concat(typeWords, tagWords, vendorWords)));

    return {
      id: product.id || handle,
      title,
      handle,
      product_type: type,
      tags,
      vendor,
      image,
      priceText: price ? money(price) : '',
      _cleanTitle: clean(title),
      _cleanType: clean(type),
      _cleanTags: clean(tags.join(' ')),
      _cleanVendor: clean(vendor),
      _titleWords: titleWords,
      _typeWords: typeWords,
      _tagWords: tagWords,
      _vendorWords: vendorWords,
      _words: allWords,
      _haystack: clean([title, type, tags.join(' '), vendorWords.join(' '), handle].join(' '))
    };
  }

  function serializableProduct(product) {
    return {
      id: product.id,
      title: product.title,
      handle: product.handle,
      product_type: product.product_type,
      tags: product.tags,
      vendor: product.vendor,
      image: product.image,
      priceText: product.priceText
    };
  }

  function rebuildVocabulary(products) {
    const frequency = new Map();

    products.forEach((product) => {
      const uniqueWords = new Set(product._words.filter((word) => word.length >= 2 && !/^\d+$/.test(word)));
      uniqueWords.forEach((word) => frequency.set(word, (frequency.get(word) || 0) + 1));
    });

    wordFrequency = frequency;
    vocabulary = Array.from(frequency.keys());
    vocabularySet = new Set(vocabulary);
    vocabularyByFirst = new Map();

    vocabulary.forEach((word) => {
      const key = word[0] || '';
      if (!vocabularyByFirst.has(key)) vocabularyByFirst.set(key, []);
      vocabularyByFirst.get(key).push(word);
    });
  }

  function readCachedIndex() {
    try {
      const raw = window.localStorage.getItem(CONFIG.cacheKey);
      if (!raw) return [];
      const cached = JSON.parse(raw);
      if (!cached || cached.version !== 3 || !Array.isArray(cached.products)) return [];
      if (Date.now() - Number(cached.createdAt || 0) > CONFIG.cacheTtlMs) return [];
      return cached.products.map(compactProduct).filter((product) => product.title && product.handle);
    } catch (error) {
      return [];
    }
  }

  function cacheIndex(products) {
    try {
      const payload = {
        version: 3,
        createdAt: Date.now(),
        products: products.map(serializableProduct)
      };
      window.localStorage.setItem(CONFIG.cacheKey, JSON.stringify(payload));
    } catch (error) {
      // Search remains functional when storage is unavailable or full.
    }
  }

  async function loadProductIndex() {
    if (productIndex.length) return productIndex;
    if (indexPromise) return indexPromise;

    indexPromise = (async () => {
      const cached = readCachedIndex();
      if (cached.length) {
        productIndex = cached;
        rebuildVocabulary(productIndex);
        return productIndex;
      }

      const items = [];
      for (let page = 1; page <= CONFIG.maxProductPages; page++) {
        const url = `${CONFIG.productsEndpoint}?limit=250&page=${page}`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) break;

        const data = await response.json();
        const products = Array.isArray(data.products) ? data.products : [];
        products.forEach((product) => {
          const compact = compactProduct(product);
          if (compact.title && compact.handle) items.push(compact);
        });

        if (products.length < 250) break;
      }

      productIndex = items;
      rebuildVocabulary(productIndex);
      if (productIndex.length) cacheIndex(productIndex);
      return productIndex;
    })().catch(() => {
      indexPromise = null;
      return [];
    });

    return indexPromise;
  }

  function correctionThreshold(token) {
    if (token.length <= 3) return 0.91;
    if (token.length === 4) return 0.84;
    if (token.length <= 6) return 0.78;
    return 0.74;
  }

  function correctTokenFromCatalog(token) {
    token = clean(token);
    if (!token || token.length < 3 || /^\d+$/.test(token) || vocabularySet.has(token)) return token;

    const pool = vocabularyByFirst.get(token[0]) || vocabulary;
    let bestWord = token;
    let bestScore = 0;
    let secondScore = 0;

    for (const candidate of pool) {
      if (Math.abs(candidate.length - token.length) > Math.max(3, Math.ceil(token.length * 0.45))) continue;

      const similarity = tokenSimilarity(token, candidate);
      const frequencyBoost = Math.min(0.035, Math.log10((wordFrequency.get(candidate) || 1) + 1) * 0.014);
      const score = similarity + frequencyBoost;

      if (score > bestScore) {
        secondScore = bestScore;
        bestScore = score;
        bestWord = candidate;
      } else if (score > secondScore) {
        secondScore = score;
      }
    }

    if (bestScore < correctionThreshold(token)) return token;
    if (bestScore - secondScore < 0.012 && bestScore < 0.94) return token;
    return bestWord;
  }

  function correctQueryFromCatalog(query) {
    const known = replaceKnownMisspelling(query);
    const queryWords = words(known);
    if (!queryWords.length || !vocabulary.length) return known;

    const correctedWords = queryWords.map(correctTokenFromCatalog);
    return correctedWords.join(' ');
  }

  function bestWordScore(token, candidates) {
    let best = 0;
    for (const candidate of candidates) {
      if (!candidate) continue;
      if (candidate === token) return 1;
      best = Math.max(best, tokenSimilarity(token, candidate));
    }
    return best;
  }

  function orderedTokenBoost(queryTokens, titleWords) {
    let cursor = -1;
    let ordered = 0;
    queryTokens.forEach((token) => {
      const next = titleWords.findIndex((word, index) => index > cursor && tokenSimilarity(token, word) >= 0.86);
      if (next >= 0) {
        ordered += 1;
        cursor = next;
      }
    });
    return queryTokens.length ? ordered / queryTokens.length : 0;
  }

  function scoreProduct(product, query) {
    const q = clean(query);
    const qt = tight(query);
    if (!q || q.length < CONFIG.minChars) return 0;

    if (product._cleanTitle === q) return 320;
    if (product._cleanTitle.startsWith(q)) return 285;
    if (tight(product._cleanTitle).startsWith(qt)) return 275;
    if (product._cleanTitle.includes(q)) return 260;
    if (product._haystack.includes(q)) return 235;
    if (tight(product._haystack).includes(qt)) return 225;

    const queryTokens = words(q).filter((token) => token.length > 1);
    if (!queryTokens.length) return 0;

    let titleTotal = 0;
    let supportingTotal = 0;
    let strongMatches = 0;
    let exactMatches = 0;

    queryTokens.forEach((token) => {
      const titleScore = bestWordScore(token, product._titleWords);
      const supportingScore = Math.max(
        bestWordScore(token, product._typeWords),
        bestWordScore(token, product._tagWords),
        bestWordScore(token, product._vendorWords)
      );

      titleTotal += titleScore;
      supportingTotal += supportingScore;
      if (Math.max(titleScore, supportingScore) >= 0.78) strongMatches += 1;
      if (product._words.includes(token)) exactMatches += 1;
    });

    const coverage = strongMatches / queryTokens.length;
    const titleAverage = titleTotal / queryTokens.length;
    const supportAverage = supportingTotal / queryTokens.length;
    const exactCoverage = exactMatches / queryTokens.length;
    const orderBoost = orderedTokenBoost(queryTokens, product._titleWords);
    const phraseBoost = phraseSimilarity(q, product._cleanTitle);

    if (coverage < 0.5 && titleAverage < 0.76 && phraseBoost < 0.74) return 0;

    return Math.round(
      titleAverage * 112 +
      supportAverage * 34 +
      coverage * 72 +
      exactCoverage * 45 +
      orderBoost * 28 +
      phraseBoost * 36
    );
  }

  async function fetchNativeSuggest(query) {
    const url = `${CONFIG.searchSuggestEndpoint}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${CONFIG.limit}&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) return [];
    const data = await response.json();
    return (((data || {}).resources || {}).results || {}).products || [];
  }

  function normalizeNativeProduct(product) {
    return {
      id: product.id || product.url || product.title,
      title: product.title,
      handle: product.url ? String(product.url).replace('/products/', '').split('?')[0].replace(/^\//, '') : '',
      url: product.url,
      image: product.image,
      priceText: product.price || product.price_min || ''
    };
  }

  function mergeProducts(...groups) {
    const merged = [];
    const seen = new Set();

    groups.flat().forEach((product) => {
      if (!product) return;
      const key = product.handle || product.url || product.id || product.title;
      if (!key || seen.has(key)) return;
      seen.add(key);
      merged.push(product);
    });

    return merged.slice(0, CONFIG.limit);
  }

  async function getMatches(rawQuery, onFastResults) {
    const raw = clean(rawQuery);
    const knownCorrected = replaceKnownMisspelling(raw);
    const nativePromise = fetchNativeSuggest(knownCorrected).catch(() => []);
    const catalogPromise = loadProductIndex();

    const nativeInitial = await nativePromise;
    if (nativeInitial.length && typeof onFastResults === 'function') {
      onFastResults({
        label: knownCorrected,
        corrected: knownCorrected !== raw,
        products: nativeInitial.map(normalizeNativeProduct)
      });
    }

    const catalog = await catalogPromise;
    const catalogCorrected = catalog.length ? correctQueryFromCatalog(knownCorrected) : knownCorrected;
    const finalQuery = catalogCorrected || knownCorrected || raw;
    const nativeFinal = finalQuery !== knownCorrected
      ? await fetchNativeSuggest(finalQuery).catch(() => [])
      : nativeInitial;

    const fuzzyProducts = catalog
      .map((product) => ({ product, score: scoreProduct(product, finalQuery) }))
      .filter((item) => item.score >= 118)
      .sort((a, b) => b.score - a.score)
      .slice(0, CONFIG.limit)
      .map((item) => item.product);

    return {
      label: finalQuery,
      corrected: finalQuery !== raw,
      products: mergeProducts(
        nativeFinal.map(normalizeNativeProduct),
        fuzzyProducts,
        nativeInitial.map(normalizeNativeProduct)
      )
    };
  }

  function ensureStyles() {
    if (document.getElementById('ms-fuzzy-search-style')) return;
    const style = document.createElement('style');
    style.id = 'ms-fuzzy-search-style';
    style.textContent = `
      .ms-fuzzy-search-menu{position:absolute;z-index:2147483000;background:#fff;border:1px solid rgba(0,0,0,.12);box-shadow:0 12px 30px rgba(0,0,0,.14);border-radius:12px;overflow:hidden;max-height:480px;overflow-y:auto;font-family:inherit;color:#222}
      .ms-fuzzy-search-head{padding:10px 12px;font-size:13px;background:#fafafa;border-bottom:1px solid rgba(0,0,0,.08);color:#222;line-height:1.35}
      .ms-fuzzy-search-head strong{font-weight:700}
      .ms-fuzzy-product{display:flex;gap:10px;align-items:center;padding:10px 12px;text-decoration:none;color:inherit;border-bottom:1px solid rgba(0,0,0,.06)}
      .ms-fuzzy-product:hover{background:#f7f7f7;color:inherit}
      .ms-fuzzy-product img{width:48px;height:48px;object-fit:cover;border-radius:7px;background:#f4f4f4;flex:0 0 48px}
      .ms-fuzzy-product-title{font-size:14px;line-height:1.25;color:#222}
      .ms-fuzzy-product-price{font-size:12px;opacity:.75;margin-top:4px;color:#222}
      .ms-fuzzy-view-all{display:block;padding:12px;text-decoration:none;font-size:14px;font-weight:700;color:#222;background:#fafafa}
      @media(max-width:767px){.ms-fuzzy-search-menu{left:12px!important;right:12px!important;width:auto!important;max-height:60vh}.ms-fuzzy-product-title{font-size:13px}}
    `;
    document.head.appendChild(style);
  }

  function createMenu(input) {
    ensureStyles();
    const menu = document.createElement('div');
    menu.className = 'ms-fuzzy-search-menu';
    menu.hidden = true;
    document.body.appendChild(menu);

    const position = () => {
      const rect = input.getBoundingClientRect();
      menu.style.left = `${rect.left + window.scrollX}px`;
      menu.style.top = `${rect.bottom + window.scrollY + 6}px`;
      menu.style.width = `${Math.max(rect.width, 300)}px`;
    };

    window.addEventListener('resize', position);
    window.addEventListener('scroll', position, true);
    return { menu, position };
  }

  function getImage(product) {
    if (product.image && typeof product.image === 'string') return product.image;
    if (product.image && typeof product.image === 'object') return product.image.url || product.image.src || '';
    return '';
  }

  function getPrice(product) {
    return product.priceText ? String(product.priceText).replace(/<[^>]*>/g, '') : '';
  }

  function getUrl(product) {
    return product.url || (product.handle ? `/products/${product.handle}` : '#');
  }

  function render(input, result) {
    const item = inputState.get(input);
    if (!item || !result || !result.products.length) return;

    item.position();
    item.menu.innerHTML = '';

    const head = document.createElement('div');
    head.className = 'ms-fuzzy-search-head';
    head.append(result.corrected ? 'Did you mean ' : 'Suggested products for ');
    const strong = document.createElement('strong');
    strong.textContent = result.label;
    head.append(strong);
    if (result.corrected) head.append('?');
    item.menu.appendChild(head);

    result.products.forEach((product) => {
      const link = document.createElement('a');
      link.className = 'ms-fuzzy-product';
      link.href = getUrl(product);

      const imageUrl = getImage(product);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = product.title || '';
        image.loading = 'lazy';
        link.appendChild(image);
      }

      const text = document.createElement('div');
      const title = document.createElement('div');
      title.className = 'ms-fuzzy-product-title';
      title.textContent = product.title || '';
      text.appendChild(title);

      const price = getPrice(product);
      if (price) {
        const priceElement = document.createElement('div');
        priceElement.className = 'ms-fuzzy-product-price';
        priceElement.textContent = price;
        text.appendChild(priceElement);
      }

      link.appendChild(text);
      item.menu.appendChild(link);
    });

    const viewAll = document.createElement('a');
    viewAll.className = 'ms-fuzzy-view-all';
    viewAll.href = `/search?q=${encodeURIComponent(result.label)}&type=product`;
    viewAll.textContent = `View all results for "${result.label}"`;
    item.menu.appendChild(viewAll);

    item.lastCorrection = result.label;
    item.hasResults = true;
    item.menu.hidden = false;
  }

  function hide(input) {
    const item = inputState.get(input);
    if (!item) return;
    item.menu.hidden = true;
    item.lastCorrection = '';
    item.hasResults = false;
  }

  function isMobileTriggerOnly(input) {
    return window.matchMedia('(max-width: 767px)').matches &&
      Boolean(input.closest('.section-animated-header-search, .collection-search'));
  }

  async function handleInput(input) {
    if (isMobileTriggerOnly(input)) return hide(input);

    const item = inputState.get(input);
    if (!item) return;

    const raw = input.value || '';
    if (clean(raw).length < CONFIG.minChars) return hide(input);

    const requestId = ++item.requestId;
    const isCurrent = () => item.requestId === requestId && clean(input.value) === clean(raw);

    const result = await getMatches(raw, (fastResult) => {
      if (isCurrent()) render(input, fastResult);
    });

    if (!isCurrent()) return;
    if (result.products.length) render(input, result);
    else hide(input);
  }

  function attach(input) {
    if (!input || input.dataset.msFuzzyAttached === 'true') return;
    input.dataset.msFuzzyAttached = 'true';

    inputState.set(input, {
      ...createMenu(input),
      lastCorrection: '',
      hasResults: false,
      requestId: 0
    });

    const run = debounce(() => handleInput(input), CONFIG.debounceMs);
    input.addEventListener('input', run);
    input.addEventListener('focus', () => handleInput(input));
    input.addEventListener('blur', () => window.setTimeout(() => hide(input), 180));

    const form = input.closest('form');
    if (form && form.dataset.msFuzzySubmitAttached !== 'true') {
      form.dataset.msFuzzySubmitAttached = 'true';
      form.addEventListener('submit', () => {
        const currentInput = form.querySelector('input[name="q"], input[type="search"]');
        if (!currentInput) return;

        const knownCorrection = replaceKnownMisspelling(currentInput.value);
        const state = inputState.get(currentInput);
        const bestCorrection = state && state.lastCorrection;

        if (bestCorrection && bestCorrection !== clean(currentInput.value)) {
          currentInput.value = bestCorrection;
        } else if (knownCorrection && knownCorrection !== clean(currentInput.value)) {
          currentInput.value = knownCorrection;
        }
      }, true);
    }
  }

  function redirectKnownSearchPage() {
    if (!/\/search\/?$/.test(window.location.pathname)) return false;

    const url = new URL(window.location.href);
    const rawQuery = url.searchParams.get('q') || '';
    const corrected = replaceKnownMisspelling(rawQuery);
    if (!corrected || corrected === clean(rawQuery)) return false;

    url.searchParams.set('q', corrected);
    url.searchParams.set('type', 'product');
    window.location.replace(url.toString());
    return true;
  }

  async function improveEmptySearchPage() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;

    const countElement = document.querySelector('[id^="SearchSection"][data-search-count]');
    const count = countElement ? Number(countElement.dataset.searchCount || 0) : null;
    if (count !== 0) return;

    const url = new URL(window.location.href);
    const rawQuery = url.searchParams.get('q') || '';
    if (clean(rawQuery).length < CONFIG.minChars) return;

    const catalog = await loadProductIndex();
    if (!catalog.length) return;

    const corrected = correctQueryFromCatalog(rawQuery);
    if (!corrected || corrected === clean(rawQuery)) return;

    url.searchParams.set('q', corrected);
    url.searchParams.set('type', 'product');
    window.location.replace(url.toString());
  }

  function scan() {
    document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach(attach);
  }

  if (redirectKnownSearchPage()) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scan();
      improveEmptySearchPage();
    });
  } else {
    scan();
    improveEmptySearchPage();
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
